import React from 'react';

interface ModelSelectorProps {
  selectedModel: 'Claude' | 'GPT';
  onModelSelect: (model: 'Claude' | 'GPT') => void;
}

const ModelSelector: React.FC<ModelSelectorProps> = ({ selectedModel, onModelSelect }) => {
  return (
    <div className="flex gap-2">
      <button
        onClick={() => {
          if (selectedModel !== 'Claude') {
            onModelSelect('Claude');
          }
        }}
        className={`px-4 py-2 rounded-lg transition-colors ${
          selectedModel === 'Claude'
            ? 'bg-purple-600 text-white'
            : 'bg-gray-200  text-gray-700  hover:bg-gray-300 '
        }`}
      >
        Claude
      </button>
      <button
        onClick={() => {
          if (selectedModel !== 'GPT') {
            onModelSelect('GPT');
          }
        }}
        className={`px-4 py-2 rounded-lg transition-colors ${
          selectedModel === 'GPT'
            ? 'bg-green-600 text-white'
            : 'bg-gray-200  text-gray-700  hover:bg-gray-300 '
        }`}
      >
        GPT
      </button>
    </div>
  );
};

export default ModelSelector; 